var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseService } from './rest/base.service';
import { AppConfigService } from './app-config.service';
import { HttpClient } from '@angular/common/http';
import { AuthorizationService } from './authorization.service';
import { MessageService } from './message.service';
import { CacheService } from './cache.service';
import { UrlHelper } from '../utils/url-helper';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./authorization.service";
import * as i3 from "./message.service";
import * as i4 from "./cache.service";
var TokenService = /** @class */ (function (_super) {
    __extends(TokenService, _super);
    function TokenService(http, authorization, messages, cache) {
        var _this = _super.call(this, http, authorization, messages, cache) || this;
        _this.endpointUri = '';
        _this.apiBaseUrl = UrlHelper.trimUrl(AppConfigService.settings.oauthUrl);
        return _this;
    }
    TokenService.prototype.getAll = function () {
        throw new Error('Method not implemented.');
    };
    /**
     * Fetch a short-living token for file-downloads which require a token-parameter
     *
     * @returns {Observable<OAuthToken>}
     * @memberof TokenService
     */
    TokenService.prototype.getFileToken = function () {
        return this.getRequestCustom(this.apiBaseUrl + '/Authorization/FileToken');
    };
    TokenService.prototype.get = function (id) {
        throw new Error('Method not implemented.');
    };
    TokenService.prototype.add = function (entity) {
        throw new Error('Method not implemented.');
    };
    TokenService.prototype.update = function (entity) {
        throw new Error('Method not implemented.');
    };
    TokenService.prototype.delete = function (id) {
        throw new Error('Method not implemented.');
    };
    TokenService.ngInjectableDef = i0.defineInjectable({ factory: function TokenService_Factory() { return new TokenService(i0.inject(i1.HttpClient), i0.inject(i2.AuthorizationService), i0.inject(i3.MessageService), i0.inject(i4.CacheService)); }, token: TokenService, providedIn: "root" });
    return TokenService;
}(BaseService));
export { TokenService };
